"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const MissingElement = ({
  children
}) => {
  const styles = {
    padding: '0.25rem',
    background: '#FFF7ED',
    borderRadius: '0.375rem',
    border: '1px dashed #F97316'
  };
  return (0, _jsxRuntime.jsx)("div", {
    style: styles,
    children: children
  });
};
var _default = MissingElement;
exports.default = _default;